import {api} from '../../utils/api'

export default {

    /**
     * load Tfinstances
     * @param commit
     * @param id
     * @param showAll
     * @returns {*|Promise|Promise<any>}
     */
    loadTfinstances({commit}, {id, showAll}) {
        return api.call(commit, 'get', '/api/tfinstance/'+id+"/"+(showAll ? 1 : 0), null,  'SET_TFINSTANCES');
    },

    /**
     * Delete Tfinstances
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    deleteTfinstance({commit}, id) {
        return api.call(commit, 'delete', '/api/tfinstance/' + id, null, 'DELETE_TFINSTANCES');
    },

    /**
     * create new Tfinstance
     * @param commit
     * @param task_id
     * @param released
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    createTfinstance({commit}, {task_id, released}) {
        // Create new field
        return api.call(commit, 'post', '/api/tfinstance', {task_id: task_id, released}, 'SET_TFINSTANCES');
    },

    /**
     * get table item instance node
     * @param commit
     * @param instance_id
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    getTableItemInstance({commit}, instance_id) {
        // Create new field
        return api.call(commit, 'get', `/api/tfinstance/table-item/${instance_id}`);
    },


}
